import React, { ReactNode } from 'react';
import classNames from 'classnames';
import useMatchMedia from 'hooks/useMatchMedia';
import AgreementPdfViewer from 'components/AgreementPdfViewer';
import { AgreementField } from 'models/Agreement';
import FieldEditorProvider from './providers/FieldEditor';
import FieldPalette from './components/FieldPalette';
import PageFieldsLayer from './components/PageFieldsLayer';
import EditorBottomSheet from './components/EditorBottomSheet';

import './AgreementFieldEditor.styles.scss';
import './AgreementFieldEditor.styles.responsive.scss';

type AgreementFieldEditorProps = {
  className?: string;
  fileUrl?: string;
  fields: AgreementField[];
  invalidFieldIds: string[];
  sidebarHeader?: ReactNode;
  emptyDocument?: ReactNode;
  onFieldsChange: (fields: AgreementField[]) => void;
  onDocumentLoad?: (pageCount: number) => void;
};

const AgreementFieldEditor: React.FC<AgreementFieldEditorProps> = (props) => {
  const {
    className,
    fileUrl,
    fields,
    invalidFieldIds,
    sidebarHeader,
    emptyDocument,
    onFieldsChange,
    onDocumentLoad,
  } = props;

  const isPhablet = useMatchMedia('isPhablet');

  const classes = classNames('agreement-field-editor', className);

  return (
    <FieldEditorProvider
      fields={fields}
      invalidFieldIds={invalidFieldIds}
      onChange={onFieldsChange}
    >
      <div className={classes}>
        {!isPhablet && (
          <aside className="agreement-field-editor__sidebar">
            {sidebarHeader}
            <FieldPalette isDisabled={!fileUrl} />
          </aside>
        )}

        <div className="agreement-field-editor__document">
          {fileUrl ? (
            <AgreementPdfViewer
              fileUrl={fileUrl}
              PageLayer={PageFieldsLayer}
              onDocumentLoad={onDocumentLoad}
            />
          ) : (
            emptyDocument
          )}
        </div>

        {isPhablet && (
          <EditorBottomSheet
            header={sidebarHeader}
            isPaletteDisabled={!fileUrl}
          />
        )}
      </div>
    </FieldEditorProvider>
  );
};

export default AgreementFieldEditor;
